import dataProvider from "../../../../../providers/data-provider";
import DashboardFilter from "./dashboard-filter";

const fetchClasses = async (shouldFetch, search, institutionBranchId, academicPeriodId) => {
    if (shouldFetch) {
        const response = await dataProvider.getList(
            'classes',
            {
                pagination: { page: 1, perPage: 20 },
                sort: { field: 'name', order: 'ASC' },
                filter: { [`class.name`]: search, [`institution_branch.id`]: institutionBranchId, [`academic_period.id`]: academicPeriodId }
            })
        return response.data;
    }
    else { return [] }
}

export const ClassFilter = ({ filters, setFilters }) => {

    const shouldFetch = filters?.institutionBranchId && filters?.academicPeriodId

    return <DashboardFilter
        filterKey="classId"
        label="Turma"
        value={filters.class?.id}
        setFilters={setFilters}
        fetchOptions={(search) => fetchClasses(shouldFetch, search, filters?.institutionBranchId, filters?.academicPeriodId)}
        disabled={!shouldFetch}
    />
}